import { render, staticRenderFns } from "./Comission.vue?vue&type=template&id=77ef31bd&scoped=true&"
import script from "./Comission.vue?vue&type=script&lang=js&"
export * from "./Comission.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77ef31bd",
  null
  
)

export default component.exports